import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=60aa5afe&scoped=true&"
import script from "./CreateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=60aa5afe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa5afe",
  null
  
)

export default component.exports